import { post } from './api';

export default {
  subscribeGuest: async function (data) {
    return await post('/guest/boater_list/subscribe', data);
  }
};
